import React from 'react';
const links = [{
  label: 'Terms',
  href: '#terms'
}, {
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Refund Policy',
  href: '#refund'
}, {
  label: 'Contact',
  href: 'mailto:hello@cosmetologyinstructorready.com'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-157" data-mp="3a50vwtgt4640">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-158" data-mp="3f4ds44tkipj9">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-159" data-mp="3k2p1kefyay0y">
          Cosmetology Instructor Ready™
        </p>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-160" data-mp="3o2pge06ypb8j">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-161" data-mp="1trartmpothud">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-162" data-mp="nil56qtlg33">
        © 2026 Cosmetology Instructor Ready™. A digital teaching-resource system for beauty educators. It
        does not provide professional licensing or government-recognized certification. Secure checkout —
        payments are processed in your local currency.
      </p>
    </footer>;
}